import * as $actions from "../action-types/manage-days-off";

const initialState = {
  loading: false,
  edited: false,
  daysOff: [],
  rangeDaysSelected: {},
  singleDaySelected: '',
  specialEventReasonSelected: '',
  values: {
    drIsOpened24Hours: '',
    drIsClosed: '',
    drTimeOpen: '',
    drTimeClose: '',

    dtIsOpened24Hours: '',
    dtIsClosed: '',
    dtTimeOpen: '',
    dtTimeClose: '',

    dhIsOpened24Hours: '',
    dhIsClosed: '',
    dhTimeOpen: '',
    dhTimeClose: '',

    ctIsOpened24Hours: '',
    ctIsClosed: '',
    ctTimeOpen: '',
    ctTimeClose: '',

    crIsOpened24Hours: '',
    crIsClosed: '',
    crTimeOpen: '',
    crTimeClose: '',

    breakfastTimeOpen: '',
    breakfastTimeClose: '',

    lunchTimeOpen: '',
    lunchTimeClose: '',

    snackTimeOpen: '',
    snackTimeClose: '',

    dinnerTimeOpen: '',
    dinnerTimeClose: '',

    lateNightTimeOpen: '',
    lateNightTimeClose: '',
  },
  error: '',
  status: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case $actions.SET_REANGE_DAYS:
      return {
        ...state,
        rangeDaysSelected: action.payload,
      };
    case $actions.SET_DEFAULT_RANGE:
      return {
        ...state,
        rangeDaysSelected: {},
      };
    case $actions.SET_SINGLE_DAY:
      return {
        ...state,
        singleDaySelected: action.payload,
      };
    case $actions.SET_DEFAULT_SINGLE:
      return {
        ...state,
        singleDaySelected: '',
      };
    case $actions.SPECIAL_EVENT_SET_EDITED:
      return {
        ...state,
        edited: action.payload,
      };
    case $actions.SET_SPECIAL_EVENT_OPERATION_HOUR:
      return {
        ...state,
        values: {
          ...state.values,
          [action.payload.hourName]: action.payload.hourValue,
        },
      };
    case $actions.SET_DEFAULT_SPECIAL_EVENT_REASON_SELECTED:
      return {
        ...state,
        specialEventReasonSelected: '',
      };
    case $actions.SET_SPECIAL_EVENT_REASON_SELECTED:
      return {
        ...state,
        specialEventReasonSelected: action.payload.specialEventReasonSelected,
      };
    default:
      return state;
  }
}
